/*
 * cart-drawer.js — UI-Island für den Cart-Drawer (WP 1.4).
 * Die Cart-LOGIK lebt in cart.js; overlay.js liefert Dialog/Fokus/Escape/Scroll-Lock.
 * Diese Datei: Section registrieren, Drawer bei cart:added (just-added) / cart:open (Liste) öffnen,
 * Modus toggeln (just-added vs. Voll-Liste), Stepper/Undo/Cross-Sell-Add via Event-Delegation,
 * Cross-Sell laden (Product-Recommendations-API intent=complementary, dedupe, ohne Cart-Items).
 *
 * Genau EINE aria-live-Region: die im Header ([data-cart-title]-Container, role=status im Markup).
 */
(function () {
  'use strict';
  var H = window.Homedia;
  if (!H || !H.cart || !H.overlay) return;

  var PANEL_ID = 'cart-drawer';
  var panel = document.getElementById(PANEL_ID);
  if (!panel) return;

  // Section beim kanonischen Controller fürs Bundled Section Rendering anmelden.
  H.cart.registerSection({ id: PANEL_ID, selector: '[data-cart-drawer-contents]' });

  var lastTrigger = null;
  var pendingMode = 'list';       // 'added' | 'list' — was beim nächsten Render anzuwenden ist
  var pendingAddedKeys = null;    // Line-Keys der zuletzt hinzugefügten Position(en)
  var suppressNextAdded = false;  // interner Add (Cross-Sell): kein just-added-Takeover

  function config() {
    var el = panel.querySelector('[data-cart-drawer-config]');
    if (!el) return { showCrossSell: true, recommendationsLimit: 4 };
    try { return JSON.parse(el.textContent) || {}; } catch (e) { return { showCrossSell: true, recommendationsLimit: 4 }; }
  }

  function rootUrl() {
    var r = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return r.charAt(r.length - 1) === '/' ? r : r + '/';
  }

  // ---- Modus anwenden (nach jedem Render aufrufen) ----
  function applyMode() {
    var title = panel.querySelector('[data-cart-title]');
    var check = panel.querySelector('[data-cart-check]');
    var addedWrap = panel.querySelector('[data-cart-added]');
    var lines = panel.querySelector('[data-cart-lines]');
    if (!title) return; // leerer Warenkorb: kein Modus

    var isAdded = pendingMode === 'added' && pendingAddedKeys && pendingAddedKeys.length;

    title.textContent = isAdded
      ? (title.getAttribute('data-title-added') || title.textContent)
      : (title.getAttribute('data-title-default') || title.textContent);
    if (check) check.hidden = !isAdded;

    if (addedWrap) {
      addedWrap.hidden = !isAdded;
      var slots = addedWrap.querySelectorAll('[data-added-line-key]');
      Array.prototype.forEach.call(slots, function (slot) {
        var match = isAdded && pendingAddedKeys.indexOf(slot.getAttribute('data-added-line-key')) !== -1;
        slot.hidden = !match;
      });
    }
    if (lines) lines.hidden = isAdded; // im just-added-Modus die Voll-Liste verbergen
    // Footer-CTA ist in beiden Modi der statische „Zur Kasse"-Link (Markup) — kein Toggle nötig.
  }

  // ---- Drawer öffnen ----
  function openDrawer() {
    if (H.overlay.isOpen(panel)) { applyMode(); return; }
    H.overlay.open(panel, { trigger: lastTrigger, labelledby: 'hm-cart-title' });
    applyMode();
  }

  // ---- Events vom Controller ----
  document.addEventListener('cart:added', function (e) {
    if (e.detail && e.detail.silent) {
      // Stiller Add (z. B. Merkliste „In den Warenkorb"): Inhalt ist via Bundled
      // Rendering bereits aktualisiert — Drawer NICHT öffnen (Nutzer bleibt in der Merkliste).
      if (H.overlay.isOpen(panel)) { pendingMode = 'list'; pendingAddedKeys = null; applyMode(); }
      return;
    }
    if (suppressNextAdded) {
      // Cross-Sell-Add: Liste-Modus halten, nur Inhalt aktualisieren.
      suppressNextAdded = false;
      pendingMode = 'list';
      pendingAddedKeys = null;
      applyMode();
      markCrossSellInCart();
      loadCrossSell({});
      return;
    }
    var items = (e.detail && e.detail.items) || [];
    pendingAddedKeys = items.map(function (it) { return it.key; }).filter(Boolean);
    // Produkt-IDs der eben hinzugefügten Positionen → API-Fallback primär passend zu DEM Produkt.
    var addedPids = items.map(function (it) { return it.product_id; }).filter(Boolean);
    pendingMode = pendingAddedKeys.length ? 'added' : 'list';
    lastTrigger = document.activeElement && document.activeElement !== document.body ? document.activeElement : null;
    openDrawer();
    loadCrossSell({ keys: pendingAddedKeys, priorityIds: addedPids });
  });

  document.addEventListener('cart:open', function () {
    pendingMode = 'list';
    pendingAddedKeys = null;
    lastTrigger = document.activeElement && document.activeElement !== document.body ? document.activeElement : null;
    openDrawer();
    loadCrossSell({});
  });

  // ---- Ankunft von /cart ----
  // /cart ist keine Warenkorb-Seite (der Drawer IST der Warenkorb), wird von Shopify aber fest
  // verlinkt — u. a. vom Taschen-Symbol im Checkout. sections/main-cart.liquid leitet von dort auf
  // die Startseite um und hinterlässt dieses Flag; hier öffnen wir den Drawer im Listen-Modus.
  // sessionStorage (nicht localStorage): gilt nur für diesen Tab und überlebt keinen Neustart.
  try {
    if (sessionStorage.getItem('hm-open-cart') === '1') {
      sessionStorage.removeItem('hm-open-cart');
      pendingMode = 'list';
      pendingAddedKeys = null;
      openDrawer();
      loadCrossSell({});
    }
  } catch (e) {
    // sessionStorage kann in strengen Datenschutz-Modi werfen — dann eben kein Auto-Öffnen.
  }

  // Nach Live-Re-Render (Stepper/Undo) Modus & Cross-Sell-States neu anwenden.
  document.addEventListener('cart:updated', function () {
    if (!H.overlay.isOpen(panel)) return;
    applyMode();
    markCrossSellInCart();
  });

  // Fokus-Restore nach Live-Re-Render (F018): cart.js ersetzt bei jeder Mutation das komplette
  // Fragment ([data-cart-drawer-contents]) — der fokussierte Button wird zerstört. Geteilter
  // Helfer H.overlay.restoreFocus(panel, preferredSelector): bevorzugt das Nachfolge-Element,
  // sonst Close-Button/Panel, nur sichtbare Kandidaten (jede Cart-Line existiert doppelt:
  // Just-Added-Block + Voll-Liste, eine davon [hidden]).

  // ---- Event-Delegation: Stepper / Undo (Inhalt wird neu gerendert) ----
  panel.addEventListener('click', function (e) {
    var stepBtn = e.target.closest('[data-cart-stepper]');
    if (stepBtn) {
      e.preventDefault();
      if (stepBtn.getAttribute('aria-disabled') === 'true') return;
      var key = stepBtn.getAttribute('data-line-key');
      var qty = parseInt(stepBtn.getAttribute('data-line-qty'), 10) || 0;
      var dir = stepBtn.getAttribute('data-cart-stepper');
      var next = dir === 'inc' ? qty + 1 : Math.max(0, qty - 1);
      stepBtn.setAttribute('aria-disabled', 'true');
      H.cart.change({ id: key, quantity: next }).then(function () {
        // Re-Render ersetzt das Markup; pendingMode bleibt 'added' bis Drawer schließt.
        applyMode();
        markCrossSellInCart();
        H.overlay.restoreFocus(panel, '[data-cart-stepper="' + dir + '"][data-line-key="' + key + '"]');
      }).catch(function () {
        stepBtn.removeAttribute('aria-disabled');
      });
      return;
    }

    // Manuelle Mengeneingabe wird unten über 'change' behandelt (nicht hier über Klick).

    // Zeile entfernen (X-Button) — setzt die Menge auf 0.
    var rmBtn = e.target.closest('[data-cart-remove]');
    if (rmBtn) {
      e.preventDefault();
      if (rmBtn.getAttribute('aria-disabled') === 'true') return;
      var rmKey = rmBtn.getAttribute('data-line-key');
      rmBtn.setAttribute('aria-disabled', 'true');
      H.cart.change({ id: rmKey, quantity: 0 }).then(function () {
        applyMode();
        markCrossSellInCart();
        H.overlay.restoreFocus(panel); // Zeile entfernt → Close-Button/Panel
      }).catch(function () {
        rmBtn.removeAttribute('aria-disabled');
      });
      return;
    }

    var undoBtn = e.target.closest('[data-cart-undo]');
    if (undoBtn) {
      e.preventDefault();
      undoBtn.setAttribute('aria-disabled', 'true');
      H.cart.undoLast().then(function (cart) {
        pendingMode = 'list';
        pendingAddedKeys = null;
        if (cart && cart.item_count === 0) {
          H.overlay.close(panel); // overlay.js gibt den Fokus an den Auslöser zurück
        } else {
          applyMode();
          H.overlay.restoreFocus(panel);
        }
      }).catch(function () {
        undoBtn.removeAttribute('aria-disabled');
      });
      return;
    }
  });

  // ---- Manuelle Mengeneingabe (gilt für BEIDE Popup-Modi: Add-to-Cart-Karte + Voll-Liste) ----
  // Spiegelt das Verhalten der Buy-Box: getippte Menge wird auf [1, Bestand] geklemmt, und wenn nach
  // unten korrigiert wurde, sagen wir es auch (Toast). Delegiert, weil das Markup bei jeder Mutation
  // per Bundled Section Rendering neu erzeugt wird.
  // 'change' feuert bei Blur und bei Enter — kein Request pro Tastenanschlag.
  panel.addEventListener('change', function (e) {
    var input = e.target.closest('[data-line-qty-input]');
    if (!input) return;

    var key = input.getAttribute('data-line-key');
    // Serverseitig gerenderte Menge: das ATTRIBUT ändert sich beim Tippen nicht, .value schon.
    var current = parseInt(input.getAttribute('value'), 10);
    var maxAttr = input.getAttribute('data-line-max'); // fehlt = Bestand nicht verfolgt → kein Limit
    var max = maxAttr == null ? null : parseInt(maxAttr, 10);

    var n = parseInt(input.value, 10);
    // Leer, 0 oder Unsinn → 1. Die 0 entfernt bewusst NICHT (dafür gibt es das X) — sonst löscht
    // ein Vertipper die Position.
    if (isNaN(n) || n < 1) n = 1;

    var clamped = false;
    if (max != null && !isNaN(max) && n > max) { n = Math.max(1, max); clamped = true; }
    input.value = n;

    if (clamped && H.cart.notify) {
      // Zwei Grenzen → zwei Aussagen. data-line-max-reason sagt, welche greift:
      //   'stock' → der Bestand ist erschöpft   → „Mehr als X Stück sind nicht verfügbar."
      //   'order' → das 50er-Zeilenlimit greift → „Mehr als X Stück pro Bestellung sind nicht möglich."
      // Bei 'order' wäre „nicht verfügbar" schlicht falsch — die Ware liegt ja im Regal.
      // Bewusst KEIN „Nur noch X verfügbar": Das klingt nach künstlicher Verknappung; der
      // Knappheits-Hinweis auf der PDP erscheint erst ab Restmenge < 5.
      var s = (window.theme && window.theme.strings) || {};
      var tpl = input.getAttribute('data-line-max-reason') === 'order'
        ? (s.qtyMaxPerOrder || 'Mehr als __count__ Stück pro Bestellung sind nicht möglich.')
        : (s.cartQtyCapped || 'Mehr als __count__ Stück sind nicht verfügbar.');
      H.cart.notify(tpl.replace('__count__', n));
    }
    if (n === current) return; // nach dem Klemmen unverändert → kein Request

    input.setAttribute('aria-busy', 'true');
    H.cart.change({ id: key, quantity: n }).then(function () {
      applyMode();
      markCrossSellInCart();
      H.overlay.restoreFocus(panel, '[data-line-qty-input][data-line-key="' + key + '"]');
    }).catch(function () {
      // cart.js hat bereits sichtbar gemeldet; hier nur den Busy-State lösen.
      input.removeAttribute('aria-busy');
    });
  });

  // Beim Schließen Modus zurücksetzen, damit ein späteres Header-Open die Liste zeigt.
  panel.addEventListener('overlay:close', function () {
    pendingMode = 'list';
    pendingAddedKeys = null;
  });

  // ---------- „Das passt dazu" (kuratierte Setup-Vorschläge im Add-to-Cart-Popup) ----------
  // Quelle 1 (primär): die KURATIERTEN Add-ons des Produkts (custom.addons) — dieselben, die die PDP
  //   unter „Vervollständige dein Setup" zeigt: Label + spezifischer Grund (hint_text) + Preis. Sie
  //   sind pro Zeile server-seitig als <script data-added-recos> eingebettet (snippets/cart-line-recos).
  //   Bewusst KEINE Bundle-Sets — recommended_products/„related" liefern Sets, die hier nicht hingehören.
  // Quelle 2 (Fallback): komplementäre Produkte aus der Recommendations-API, OHNE Bundles.
  var crossCache = {}; // productId|intent → recommendations[]
  var crossSeq = 0;

  function cartProductIds(cart) {
    var ids = {};
    (cart && cart.items ? cart.items : []).forEach(function (it) {
      if (it.product_id) ids[it.product_id] = true;
      if (it.variant_id) ids['v' + it.variant_id] = true;
    });
    return ids;
  }

  // Kuratierte Add-on-Vorschläge aus den eingebetteten [data-added-recos] der (just-added ODER aller)
  // Cart-Zeilen sammeln; per Varianten-ID dedupen und bereits im Cart liegende ausfiltern.
  function gatherCuratedRecos(keySet, inCart) {
    var seen = {}, out = [];
    panel.querySelectorAll('[data-added-line-key]').forEach(function (slot) {
      if (keySet && !keySet[slot.getAttribute('data-added-line-key')]) return;
      var s = slot.querySelector('[data-added-recos]');
      if (!s) return;
      var arr;
      try { arr = JSON.parse(s.textContent) || []; } catch (e) { return; }
      arr.forEach(function (r) {
        if (!r || !r.id) return;
        if (seen[r.id]) return;                          // dedupe (Variante)
        if (inCart['v' + r.id]) return;                  // Variante schon im Cart
        if (r.productId && inCart[r.productId]) return;  // Produkt schon im Cart
        seen[r.id] = true;
        out.push({ variantId: r.id, productId: r.productId, title: r.title, reason: r.reason || '', priceCents: r.price, url: r.url, image: r.image });
      });
    });
    return out;
  }

  // Empfehlungen mehrerer Quell-Produkte holen, dedupen; Bundles/Sets, im Cart liegende + nicht
  // verfügbare filtern; auf die normalisierte Pick-Form abbilden.
  function gatherApiPicks(sourceIds, intent, inCart) {
    return Promise.all(sourceIds.map(function (id) { return fetchRecs(id, intent); }))
      .then(function (groups) {
        var seen = {}, picks = [];
        groups.forEach(function (recs) {
          (recs || []).forEach(function (p) {
            if (!p || !p.id) return;
            if (p.type === 'Bundle') return;   // keine Sets im Popup
            if (inCart[p.id]) return;
            if (seen[p.id]) return;
            if (!p.available) return;
            seen[p.id] = true;
            // Erste VERFÜGBARE Variante, die nicht schon im Cart liegt — variants[0] kann
            // ausverkauft sein, obwohl p.available true ist (Add liefe in einen /cart/add-Fehler).
            var fv = null;
            (p.variants || []).some(function (v) {
              if (v && v.available && !inCart['v' + v.id]) { fv = v; return true; }
              return false;
            });
            if (!fv && !p.variant_id) return;
            var cents = typeof p.price === 'number' ? p.price : parseInt(p.price, 10);
            picks.push({ variantId: (fv && fv.id) || p.variant_id, productId: p.id, title: p.title, reason: '', priceCents: isNaN(cents) ? null : cents, url: p.url, image: p.featured_image });
          });
        });
        return picks;
      });
  }

  // opts: { keys?: [lineKey…] (just-added; sonst alle Cart-Zeilen), priorityIds?: [productId…] (API-Fallback) }
  function loadCrossSell(opts) {
    opts = opts || {};
    var cfg = config();
    var section = panel.querySelector('[data-cart-cross]');
    var list = panel.querySelector('[data-cart-cross-list]');
    var tmpl = panel.querySelector('[data-cart-cross-template]');
    if (!cfg.showCrossSell || !section || !list || !tmpl) return;

    var cart = H.cart.getState();
    if (!cart || !cart.items || !cart.items.length) { section.hidden = true; return; }

    var limit = cfg.recommendationsLimit || 4;
    var inCart = cartProductIds(cart);
    var seq = ++crossSeq;

    // 1) Kuratierte Add-ons der relevanten Zeilen (just-added, sonst alle) — mit spezifischem Grund.
    var keySet = null;
    if (opts.keys && opts.keys.length) { keySet = {}; opts.keys.forEach(function (k) { keySet[k] = true; }); }
    var curated = gatherCuratedRecos(keySet, inCart);
    if (curated.length) { renderCrossSell(curated.slice(0, limit), list, tmpl, section, inCart); return; }

    // 2) Fallback: komplementäre Produkte (ohne Sets). Quell-Produkte: just-added zuerst, dann Cart.
    var sourceIds = [];
    (opts.priorityIds || []).forEach(function (id) { if (id && sourceIds.indexOf(id) === -1) sourceIds.push(id); });
    cart.items.forEach(function (it) { if (it.product_id && sourceIds.indexOf(it.product_id) === -1) sourceIds.push(it.product_id); });
    sourceIds = sourceIds.slice(0, 4);

    gatherApiPicks(sourceIds, 'complementary', inCart).then(function (picks) {
      if (seq !== crossSeq) return;               // veraltete Antwort verwerfen
      renderCrossSell(picks.slice(0, limit), list, tmpl, section, inCart);
    }).catch(function () {
      section.hidden = true;
    });
  }

  function fetchRecs(productId, intent) {
    var cacheKey = productId + '|' + intent;
    if (crossCache[cacheKey]) return Promise.resolve(crossCache[cacheKey]);
    var url = rootUrl() + 'recommendations/products.json?product_id=' + encodeURIComponent(productId) +
      '&limit=6&intent=' + encodeURIComponent(intent);
    return fetch(url, { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (data) {
        var products = (data && data.products) || [];
        crossCache[cacheKey] = products;
        return products;
      })
      .catch(function () { return []; });
  }

  // picks: normalisiert { variantId, productId, title, reason, priceCents, url, image }
  function renderCrossSell(picks, list, tmpl, section, inCart) {
    list.textContent = '';
    if (!picks.length) { section.hidden = true; return; }

    picks.forEach(function (pick) {
      var node = tmpl.content ? tmpl.content.cloneNode(true) : null;
      if (!node) return;
      var img = node.querySelector('[data-cross-img]');
      var icon = node.querySelector('[data-cross-icon]');
      var reason = node.querySelector('[data-cross-reason]');
      var nameLink = node.querySelector('[data-cross-link-name]');
      var mediaLink = node.querySelector('[data-cross-link]');
      var price = node.querySelector('[data-cross-price]');
      var addBtn = node.querySelector('[data-cross-add]');

      if (pick.image && img) {
        img.src = pick.image;
        img.alt = pick.title || '';
        img.hidden = false;
        if (icon) icon.hidden = true;
      }
      if (nameLink) {
        nameLink.textContent = pick.title || '';
        if (pick.url) nameLink.href = pick.url;   // bereits root-/locale-relativ
      }
      if (mediaLink && pick.url) mediaLink.href = pick.url;
      if (price) {
        price.textContent = (pick.priceCents == null || isNaN(pick.priceCents)) ? '' : H.cart.formatMoney(pick.priceCents);
      }
      // SPEZIFISCHER Grund je Vorschlag (kuratiert) — NICHT mehr der wiederholte Sektions-Untertitel.
      if (reason) {
        if (pick.reason) { reason.textContent = pick.reason; reason.hidden = false; }
        else { reason.hidden = true; }
      }
      if (addBtn && pick.variantId) {
        addBtn.setAttribute('data-variant-id', pick.variantId);
        if (pick.productId) addBtn.setAttribute('data-product-id', pick.productId);
        var aria = (window.theme && window.theme.strings && window.theme.strings.cartAddNamed);
        addBtn.setAttribute('aria-label', aria ? aria.replace('{title}', pick.title || '') : (addBtn.getAttribute('aria-label') || ''));
        if (inCart['v' + pick.variantId]) markAdded(addBtn);
      } else if (addBtn) {
        addBtn.disabled = true;
      }
      list.appendChild(node);
    });
    section.hidden = false;
  }

  function markAdded(btn) {
    btn.setAttribute('data-in-cart', 'true');
    var plus = btn.querySelector('[data-cross-add-plus]');
    var done = btn.querySelector('[data-cross-add-done]');
    if (plus) plus.hidden = true;
    if (done) done.hidden = false;
  }

  function markCrossSellInCart() {
    var cart = H.cart.getState();
    if (!cart) return;
    var inCart = cartProductIds(cart);
    panel.querySelectorAll('[data-cross-add]').forEach(function (btn) {
      var vid = btn.getAttribute('data-variant-id');
      if (vid && inCart['v' + vid]) markAdded(btn);
    });
  }

  // Cross-Sell-Add (Template-Buttons liegen außerhalb des Re-Render-Fragments → ein Listener reicht).
  panel.addEventListener('click', function (e) {
    var addBtn = e.target.closest('[data-cross-add]');
    if (!addBtn) return;
    e.preventDefault();
    var vid = addBtn.getAttribute('data-variant-id');
    if (!vid || addBtn.getAttribute('aria-disabled') === 'true') return;
    addBtn.setAttribute('aria-disabled', 'true');
    // Add NICHT in den just-added-Modus springen lassen: Liste bleibt sichtbar.
    suppressNextAdded = true;
    H.cart.add({ id: vid }, { announce: true }).then(function () {
      markAdded(addBtn);
      addBtn.removeAttribute('aria-disabled');
      applyMode();
    }).catch(function () {
      addBtn.removeAttribute('aria-disabled');
    });
  });
})();
